@if (!abierto()) {
  <button
    type="button"
    class="lanzador"
    [class.lanzador--flotante]="variante() === 'flotante'"
    [attr.aria-label]="i18n.LAUNCHER | translate"
    [title]="i18n.LAUNCHER | translate"
    (click)="abrir()"
  >
    @if (variante() !== 'flotante') {
      <span
        class="lanzador__recuadro"
        [class.lanzador__recuadro--aqui]="variante() === 'aqui'"
        aria-hidden="true"
        >{{ (variante() === 'aqui' ? i18n.BUBBLE_HERE : i18n.BUBBLE) | translate }}</span
      >
    }
    <div #animacion class="lanzador__animacion" aria-hidden="true"></div>
  </button>
} @else {
  <aside class="panel" role="dialog" [attr.aria-label]="i18n.NAME | translate">
    <header class="panel__cabecera">
      <img class="panel__avatar" [src]="avatar()" [alt]="i18n.NAME | translate" />
      <div class="panel__titulo">
        <div class="panel__nombre">{{ i18n.NAME | translate }}</div>
        <div class="panel__subtitulo">{{ i18n.SUBTITLE | translate }}</div>
      </div>
      <button
        type="button"
        class="panel__accion"
        [class.panel__accion--tenue]="!mensajes().length"
        [title]="i18n.NEW_CONVERSATION | translate"
        [attr.aria-label]="i18n.NEW_CONVERSATION | translate"
        (click)="nuevaConversacion()"
      >
        <lib-icon name="SquarePen" [size]="18" />
      </button>
      <button
        type="button"
        class="panel__accion"
        [title]="i18n.MINIMIZE | translate"
        [attr.aria-label]="i18n.MINIMIZE | translate"
        (click)="minimizar()"
      >
        <lib-icon name="Minus" [size]="18" />
      </button>
      <button
        type="button"
        class="panel__accion"
        [title]="i18n.CLOSE | translate"
        [attr.aria-label]="i18n.CLOSE | translate"
        (click)="cerrar()"
      >
        <lib-icon name="X" [size]="18" />
      </button>
    </header>

    <div class="panel__cuerpo">
      @if (bienvenida()) {
        <div class="bienvenida">
          <div class="bienvenida__saludo">
            <img class="bienvenida__avatar" [src]="avatar()" alt="" />
            <div class="bienvenida__textos">
              <div class="bienvenida__hola">
                {{ i18n.GREETING | translate }}
                <span class="bienvenida__nombre">{{ i18n.NAME | translate }}</span
                >.
              </div>
              <div class="bienvenida__pregunta">{{ i18n.HELP_QUESTION | translate }}</div>
            </div>
          </div>
          <div>
            @if (opcion()) {
              <div class="bienvenida__seccion">
                {{ i18n.SUGGESTIONS_TITLE | translate: { opcion: opcion() } }}
              </div>
            }
            <div class="bienvenida__sugerencias">
              @for (s of sugerencias; track s.clave) {
                <button
                  type="button"
                  class="sugerencia"
                  [disabled]="!!bloqueo()"
                  (click)="preguntarSugerencia(s.clave)"
                >
                  <lib-icon class="sugerencia__icono" [name]="s.icono" [size]="18" />
                  <span class="sugerencia__texto">{{ s.clave | translate }}</span>
                  <lib-icon class="sugerencia__flecha" name="ArrowUpRight" [size]="16" />
                </button>
              }
            </div>
          </div>
        </div>
      }

      @for (m of mensajes(); track $index) {
        @if (m.rol === 'usuario') {
          <div class="mensaje mensaje--usuario">{{ m.texto }}</div>
        } @else {
          <div class="respuesta">
            <img class="respuesta__avatar" [src]="avatar()" alt="" />
            @if (m.aviso) {
              <div class="respuesta__globo respuesta__globo--aviso" role="alert">
                {{ m.texto | translate }}
              </div>
            } @else {
              <div class="respuesta__globo">{{ m.texto }}</div>
            }
          </div>
        }
      }

      @if (pensando()) {
        <div class="respuesta" role="status">
          <img class="respuesta__avatar" [src]="avatar()" alt="" />
          <div class="respuesta__globo respuesta__globo--pensando">
            <span class="puntos" aria-hidden="true"><span></span><span></span><span></span></span>
            @if (contextoVisible()) {
              <span class="pensando__texto">{{
                i18n.THINKING | translate: { opcion: opcion() }
              }}</span>
            }
          </div>
        </div>
      }
    </div>

    <footer class="panel__pie">
      @if (bloqueo(); as aviso) {
        <p class="bloqueo" role="status">
          <lib-icon name="CircleAlert" [size]="15" />{{ aviso | translate }}
        </p>
      }
      <div class="caja" [class.caja--foco]="enfocado()">
        <div class="caja__contexto">
          @if (contextoVisible()) {
            <span class="chip" [title]="opcion()">
              <lib-icon name="LayoutList" [size]="13" />
              <span class="chip__texto">{{ opcion() }}</span>
              <button
                type="button"
                class="chip__quitar"
                [title]="i18n.CONTEXT_REMOVE | translate"
                [attr.aria-label]="i18n.CONTEXT_REMOVE | translate"
                (click)="quitarContexto()"
              >
                <lib-icon name="X" [size]="12" />
              </button>
            </span>
          } @else if (opcion()) {
            <button type="button" class="usar-pantalla" (click)="usarEstaPantalla()">
              <lib-icon name="Plus" [size]="13" />{{ i18n.CONTEXT_USE | translate }}
            </button>
          }
          <span
            class="caja__info"
            [title]="i18n.CONTEXT_INFO | translate"
            [attr.aria-label]="i18n.CONTEXT_INFO | translate"
            role="img"
          >
            <lib-icon name="Info" [size]="15" />
          </span>
        </div>
        <textarea
          #caja
          class="caja__texto"
          rows="2"
          [value]="texto()"
          [maxLength]="topePregunta"
          [disabled]="!!bloqueo()"
          [placeholder]="i18n.PLACEHOLDER | translate"
          [attr.aria-label]="i18n.PLACEHOLDER | translate"
          (input)="alEscribir($event)"
          (keydown)="alPulsarTecla($event)"
          (focus)="enfocado.set(true)"
          (blur)="enfocado.set(false)"
        ></textarea>
        <div class="caja__acciones">
          @if (pensando()) {
            <button
              type="button"
              class="detener"
              [title]="i18n.STOP_TITLE | translate"
              (click)="detener()"
            >
              <lib-icon name="Square" [size]="13" />{{ i18n.STOP | translate }}
            </button>
          } @else {
            <button
              type="button"
              class="enviar"
              [class.enviar--listo]="lleno()"
              [disabled]="!lleno()"
              [title]="(lleno() ? i18n.SEND : i18n.SEND_EMPTY) | translate"
              [attr.aria-label]="(lleno() ? i18n.SEND : i18n.SEND_EMPTY) | translate"
              (click)="enviar()"
            >
              <lib-icon name="ArrowUp" [size]="18" />
            </button>
          }
        </div>
      </div>
      <p class="aviso">{{ i18n.DISCLAIMER | translate }}</p>
    </footer>
  </aside>
}
